// TODO: Need to have a default pattern between eslint from Customer and Service
/* eslint-disable no-unused-vars */
/* eslint-disable no-shadow */
export enum BatchTargetEnum {
  NONE = 'NONE',
  TIME = 'TIME',
  GRINDING_ENERGY = 'GRINDING_ENERGY',
  SPECIFIC_ENERGY = 'SPECIFIC_ENERGY',
  NUMBER_CYCLES = 'NUMBER_CYCLES',
  PRODUCT_RATE = 'PRODUCT_RATE'
}

export const batchTargetList = [
  BatchTargetEnum.NONE,
  BatchTargetEnum.TIME,
  BatchTargetEnum.GRINDING_ENERGY,
  BatchTargetEnum.SPECIFIC_ENERGY,
  BatchTargetEnum.NUMBER_CYCLES,
  BatchTargetEnum.PRODUCT_RATE
] as const;

export type BatchTarget = (typeof batchTargetList)[number];
